export enum MediaCollectionName {
    Location = 'location',
    Timesheet = 'timesheet',
    WorkOrderImage = 'workOrderImage',
    workOrderOnegmDoc = 'workOrderOnegmDoc',
    WorkOrderClientDoc = 'workOrderClientDoc',
    WorkOrderServicePartnerDoc = 'workOrderServicePartnerDoc'
}
